import { useMutation } from "@tanstack/react-query";
import axios from "axios";

// API endpoint for sending email
const API_URL = process.env.REACT_APP_API_URL || "https://aidex-mail-svc-487462102189.europe-west4.run.app";

// Service function to send form data to backend
const sendClientRequestEmail = async (data) => {
    try {
        const response = await axios.post(`${API_URL}/send-email`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Failed to send email");
    }
};

// Custom hook to handle email sending mutation
export const useSendEmail = () => {
    return useMutation({
        mutationFn: sendClientRequestEmail,
        onError: (error) => {
            console.error("Error sending meeting email:", error.message);
        },
        onSuccess: (data) => {
            console.log("Meeting email sent successfully:", data);
        },
    });
};
